export const visit = (vm, at) => {
at({ "en": { "composer-ui": { "pop-out": { "controls": { "expand": "Expand", "collapse": "Collapse" }, "badge": { "new": "New", "introduction": "Introducing full screen mode: You can now expand the composer for a full screen writing experience!" } } } } });
};